import './SensorSearchbar.css';
import React from 'react';
import PropTypes from 'prop-types';
import Searchbar from 'components/Searchbar';
import Icon, { IconList } from 'components/Icon';
import { FunctionCard, SensorInfoCard } from './SensorInfoCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useSensors } from 'context/SensorsContext';
import { standardizeString } from 'utils/function';
import { useSensorGroups } from 'context/SensorGroupsContext';
import { SENSOR_STATUS_ABNORMAL, SENSOR_STATUS_ALERT, SENSOR_STATUS_ATTENTION, SENSOR_STATUS_NORMAL, SENSOR_STATUS_GATE_CLOSED, SENSOR_STATUS_GATE_OPENED } from 'constants/config';
import { LockState } from 'models';
import { useGeneralSetting } from 'context/GeneralSettingContext';

const SensorSearchbar = (props) => {
    /**** States and Variables ****/
    const [searchedSensors, setSearchedSensors] = React.useState(null);
    const { sensors } = useSensors();
    const { sensorGroups } = useSensorGroups();
    const [isOpen, setIsOpen] = React.useState(false);
    const [isShow, setIsShow] = React.useState(true);
    const [filterStatus, setFilterStatus] = React.useState('');
    const keywordsRef = React.useRef([]);
    const ref = React.useRef(null);
    const { generalSetting } = useGeneralSetting();
    const [searchbarKey, setSearchbarKey] = React.useState(0); // rerender search bar
    /**** Processing ****/
    React.useEffect(() => {
        if (isOpen) {
            ref.current.focus();
        }
        else {
            window.focus();
        }
    }, [isOpen])

    //other function
    const handleClickSensor = (sensor) => {
        props.onClick(sensor);
        props.setSensorInfo([sensor]);
    }


    //listSensor 
    const handleShowAllSensors = async () => {
        setIsShow(true);
        setIsOpen(true);
    }
    const searchSensors = (keywords, status) => {
        keywordsRef.current = keywords;
        const searchResult = [];
        for (const sensor of sensors) {
            const targetGroup = sensorGroups.find(g => g.id === sensor.groupId);
            const messageInfo = targetGroup.messages && targetGroup.messages[sensor.status];
            const sensorInfo = standardizeString(sensor.managementId) + ' ' +
                standardizeString(sensor.name) + ' ' +
                standardizeString(sensor.location) + ' ' +
                standardizeString(sensor.tx) + ' ' +
                (messageInfo ? standardizeString(messageInfo.status) : '') + ' ' +
                (messageInfo ? standardizeString(messageInfo.message) : '') + ' ';
            let accepted = true;
            for (const keyword of keywords) {
                if (!sensorInfo.includes(keyword)) {
                    accepted = false;
                    break;
                }
            }
            // filter by status
            if (status && messageInfo?.value !== status) {
                accepted = false;
                if (status === SENSOR_STATUS_ALERT && sensor.isLocked === LockState.LOCKED && generalSetting.alertOn) {
                    accepted = true;
                }
            }
            if (accepted) searchResult.push(sensor);
        }
        setSearchedSensors(searchResult);
        setIsShow(true);
        setIsOpen(true)
    }
    /**** Event Handlers ****/
    const onBlur = (e) => {
        if (!ref.current.contains(e.relatedTarget)) {
            setIsOpen(false);
        }
    }
    const onChangeFilterStatus = (e) => {
        setFilterStatus(e.target.value);
        searchSensors(keywordsRef.current, e.target.value);
    }
    const onResetSearchResults = () => {
        setFilterStatus('');
        setIsOpen(false);
        setIsShow(false);
        setSearchbarKey(1 - searchbarKey);
        setSearchedSensors(null);
    }
    const onReload = () => {
        setFilterStatus('');
        searchSensors(keywordsRef.current, '');
    }
    /**** Main Render ****/
    return (
        <div className='sensor_searchbar'
            tabIndex={100}
            ref={ref}
            onBlur={onBlur}>
            {
                isOpen &&
                <div
                    className='sensor_searchbar_result_container'
                    style={{ '--padding': isShow ? '30px' : '53px' }}
                >
                    {
                        isShow && <>
                            <div className='search_flex-row result-info'>
                                <div className='search_flex-row result-count'>
                                    <label>合計： {(searchedSensors || sensors)?.length || '0'} 件</label>
                                    <div className='search_flex-row search-delete' onClick={onResetSearchResults}>
                                        <Icon icon={IconList.iconAllow} iconStyle='rotate-down' />
                                        <label style={{ color: '#5B87B4' }}>検索結果をクリア</label>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', columnGap: '10px' }}>
                                    <select
                                        value={filterStatus}
                                        onChange={onChangeFilterStatus}
                                        className='sensor_searchbar_status_select'>
                                        <option value=''>すべてのステータス</option>
                                        <option value={SENSOR_STATUS_NORMAL}>{SENSOR_STATUS_NORMAL}</option>
                                        <option value={SENSOR_STATUS_ATTENTION}>{SENSOR_STATUS_ATTENTION}</option>
                                        <option value={SENSOR_STATUS_GATE_OPENED}>{SENSOR_STATUS_GATE_OPENED}</option>
                                        <option value={SENSOR_STATUS_GATE_CLOSED}>{SENSOR_STATUS_GATE_CLOSED}</option>
                                        <option value={SENSOR_STATUS_ALERT}>{SENSOR_STATUS_ALERT}</option>
                                        <option value={SENSOR_STATUS_ABNORMAL}>{SENSOR_STATUS_ABNORMAL}</option>
                                    </select>
                                    <Icon
                                        icon={IconList.iconReload}
                                        containerStyle='icon_container'
                                        onClick={onReload} />
                                </div>
                            </div>
                            <div className='result-list'>
                                {
                                    (searchedSensors || sensors).map((sensor) => (
                                        <div key={sensor.id} className={`result-item ${sensor.id === props.sensorInfo?.[0]?.id ? 'selected' : ''}`} onClick={() => handleClickSensor(sensor)}>
                                            <SensorInfoCard
                                                markerId={sensor.id}
                                                width='27%'
                                                onViewSensorDetail={props.onViewSensorDetail}
                                                isSearchBar
                                            />
                                            <FunctionCard
                                                markerId={sensor.id}
                                                onUnlock={props.onUnlock}
                                                onViewSensorDetail={props.onViewSensorDetail}
                                                onSendMail={props.onSendMail}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </>

                    }
                    <div className='search_flex-row short-btn' onClick={() => setIsShow(!isShow)}>
                        <Icon icon={IconList.iconArrowUp} iconStyle={isShow ? '' : 'rotate-down'} />
                        <label>たたむ</label>
                    </div>
                </div>
            }
            <div className='search_flex-row sensor_searchbar'>
                <div className='search_flex-row label' onClick={handleShowAllSensors}>
                    <Icon icon={IconList.iconSensor} />
                    <label className='sensor_searchbar_label-text'>機器一覧</label>
                </div>
                <Searchbar
                    key={searchbarKey}
                    placeholder='機器を検索'
                    onSearch={(keywords) => { searchSensors(keywords, filterStatus) }}
                />
            </div>
            {
                props.hasWarningSensor &&
                <div className='alert_container'>
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{ color: 'red' }}
                        className='page_wrapper_header_button' />
                </div>
            }
        </div>

    )
}

SensorSearchbar.propTypes = {
    onClick: PropTypes.func,
    onUnlock: PropTypes.func,
    setSensorInfo: PropTypes.func,
    sensorInfo: PropTypes.array,
    onViewSensorDetail: PropTypes.func,
    onSendMail: PropTypes.func,
    hasWarningSensor: PropTypes.bool,
}

SensorSearchbar.defaultProps = {
    onClick: () => { },
    onUnlock: () => { },
    setSensorInfo: () => { },
    sensorInfo: [],
    onViewSensorDetail: () => { },
    onSendMail: () => { },
    hasWarningSensor: false,
}

export default SensorSearchbar;